module.exports = __webpack_public_path__ + "img/catE.898e2d3e.svg";